export const removeAllOrgDataFromLocalStorage = () => {
    localStorage.removeItem('user_claims')
}
